// millingStoreFunctions.js

// Actions
export const addMilling = (milling) => ({
  type: "ADD_MILLING",
  payload: milling
});

export const addMoreMillings = (millings) => ({
  type: "ADD_MORE_MILLINGS",
  payload: millings
});

export const updateMilling = (modifiedMilling) => ({
  type: "UPDATE_MILLING",
  payload: modifiedMilling
});

export const deleteMilling = (millingId) => ({
  type: "DELETE_MILLING",
  payload: millingId
});

// Reducer
export const millingReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_MILLING":
      if (!state.some((m) => m.millingId === action.payload.millingId)) {
        return [...state, action.payload];
      }
      return state;

    case "ADD_MORE_MILLINGS":
      return action.payload;

    case "UPDATE_MILLING":
      return state.map((m) =>
        m.millingId === action.payload.millingId
          ? { ...m, ...action.payload }
          : m
      );

    case "DELETE_MILLING":
      return state.filter((m) => m.millingId !== action.payload);

    default:
      return state;
  }
};
